module.exports = __webpack_public_path__ + "static/img/Perez.98cb551.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Perez.jpg
// module id = vNlY
// module chunks = 1